import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { isClientSuspended } from 'src/modules/store/cart.selectors';
import { environment } from 'src/environments/environment';
import { AppSetting } from 'src/modules/models/settings/casual-portal/app-setting';


@Component({
  selector: 'opt-suspended-banner',
  templateUrl: './suspended-banner.component.html',
  styleUrls: ['./suspended-banner.component.scss']
})
export class SuspendedBannerComponent {
  private readonly ALLOWED_ROUTES = ['/facility', '/home'];

  private readonly bannerConfig = (environment.AppSetting as AppSetting)?.SuspendedClientBanner;

  readonly heading = this.bannerConfig?.Heading ?? 'Access to your account is currently suspended';
  readonly message = this.getResolvedMessage();

  showBanner$: Observable<boolean>;

  constructor(private store: Store<unknown>, private router: Router) {
    const currentRoute$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
      startWith(this.router.url)
    );

    this.showBanner$ = combineLatest([
      this.store.select(isClientSuspended),
      currentRoute$
    ]).pipe(
      map(([suspended, url]) => suspended && this.isAllowedRoute(url))
    );
  }

  private getResolvedMessage(): string {
    const msg = this.bannerConfig?.Message ?? 'Your account is currently suspended. You cannot make new bookings until the suspension is lifted. Please contact support or navigate to "My Bookings" to make any outstanding payments. Call us on #SupportPhoneNumber# or email us at #SupportEmail# and we will help you reactivate your profile.';
    const phone = this.bannerConfig?.SupportPhoneNumber ?? '1300 023 411';
    const email = this.bannerConfig?.SupportEmail ?? 'mail@wyndham.vic.gov.au';
    return msg
      .replace(/#SupportPhoneNumber#/g, phone)
      .replace(/#SupportEmail#/g, email)
      .trim();
  }

  private isAllowedRoute(url: string): boolean {
    const path = url.split('?')[0];
    return this.ALLOWED_ROUTES.some(route => path === route || path.startsWith(route + '/'));
  }

  goToMyBookings(): void {
    window.open(environment.ApiUrl + '#/bookings', '_self');
  }
}
